"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_placeholder_loader_1 = require("@hotelplan/components.common.placeholder-loader");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const SelectInput_styles_1 = require("./SelectInput.styles");
const SelectInputWrapper_1 = __importDefault(require("./SelectInputWrapper"));
const FakeSelect = styled_components_1.default.div.attrs({
    disabled: true,
})(({ theme }) => theme.inputs.select, (0, util_theme_sxc_1.sx2CssThemeFn)(({ hasIcon }) => (0, SelectInput_styles_1.getSelectInputForceStyles)(hasIcon)));
const SelectPlaceholderWrapper = styled_components_1.default.div({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
});
const SelectInputSkeleton = props => {
    const { hideLabel, label, icon, customLabel, className } = props;
    return (react_1.default.createElement(SelectInputWrapper_1.default, { label: label, hideLabel: hideLabel, icon: icon, customLabel: customLabel },
        react_1.default.createElement(FakeSelect, { className: className }),
        react_1.default.createElement(SelectPlaceholderWrapper, null,
            react_1.default.createElement(components_common_placeholder_loader_1.PlaceholderLoader, { width: 180, height: 40, uid: "priceRangeInputSkeleton", style: { height: '100%', width: '100%' } },
                react_1.default.createElement("rect", { x: 10, y: 12, rx: 6, ry: 6, width: 120, height: 16 })))));
};
exports.default = SelectInputSkeleton;
//# sourceMappingURL=SelectInput.skeleton.js.map